var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockSmallBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .667A7.332 7.332 0 0 0 .665 8a7.332 7.332 0 0 0 7.333 7.333A7.332 7.332 0 0 0 15.333 8 7.332 7.332 0 0 0 7.999.667Zm0 13.247A5.912 5.912 0 0 1 2.084 8 5.912 5.912 0 0 1 8 2.086 5.912 5.912 0 0 1 13.913 8 5.912 5.912 0 0 1 8 13.914Zm1.827-3.087-2.51-1.825a.357.357 0 0 1-.146-.287V3.86c0-.195.16-.355.355-.355h.946c.196 0 .355.16.355.355v4.19l1.976 1.437c.16.116.192.337.076.497l-.556.766a.357.357 0 0 1-.496.077Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmallBlackIcon);
export default __webpack_public_path__ + "static/media/clock-small-black-icon.8aa901f6e15053f4307fc7d315a3188f.svg";
export { ForwardRef as ReactComponent };